export default "__VITE_ASSET__D1jQjc_$__"